"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./interfaces"));
function getValue(values, key, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    var val = values.find(function (v) {
        return v.key === key;
    });
    return val ? val.value : defaultValue;
}
exports.getValue = getValue;
function getResponderType(obj) {
    if (isCandidate(obj)) {
        return 'Candidate';
    }
    else {
        return 'Party';
    }
}
exports.getResponderType = getResponderType;
function isCandidate(obj) {
    return 'firstname' in obj;
}
exports.isCandidate = isCandidate;
function questionnaireCompleted(answers, questions) {
    var index = {};
    answers.forEach(function (a) { return (index[a.questionId] = a); });
    return questions.every(function (q) {
        var answer = index[q.id];
        return answer && answer.value >= 0;
    });
}
exports.questionnaireCompleted = questionnaireCompleted;
// i18n
function translate(item, language, fieldName) {
    if (!item.i18n) {
        console.log('Translating item. No i18n data found. Returning untranslated item.');
        return item;
    }
    var i18n = item.i18n;
    if (fieldName) {
        // Translate single field
        var translation = i18n[fieldName + "_" + language];
        if (typeof translation === 'undefined') {
            throw new Error('Translating item. No translation found for: ' + (fieldName + "_" + language));
        }
        return translation;
    }
    else {
        // Translate all fields
        var fields = Object.keys(i18n).filter(function (field) { return field.endsWith("_" + language); });
        if (!fields || !fields.length) {
            throw new Error('Translating item. No i18n fields found for language: ' + language);
        }
        var result_1 = __assign({}, item);
        fields.forEach(function (field) {
            result_1[_getFieldName(field)] = i18n[field];
        });
        return result_1;
    }
}
exports.translate = translate;
function isTranslationComplete(item) {
    if (!item.i18n) {
        return true;
    }
    var i18n = item.i18n;
    return Object.keys(i18n).every(function (key) { return !!i18n[key]; });
}
exports.isTranslationComplete = isTranslationComplete;
function _getFieldName(key) {
    return key.slice(0, key.lastIndexOf('_'));
}
//# sourceMappingURL=index.js.map